'use strict';

var FaresFilterByClassFactory = function FaresFilterByClassFactory(DataFilter) {
  function FaresFilterByClass() {
    DataFilter.call(this, ['fares-chart-mode', 'fares-mode', 'fares-average-mode', 'mapped-fares-mode'], 'class-usage', 1);
  }
  FaresFilterByClass.prototype = Object.create(DataFilter.prototype);
  FaresFilterByClass.prototype.filter = function (data, range) {
    range = range[0];
    var classes = range.classes;
    return DataFilter.prototype.filter(data, classes, 'className');
  };
  return FaresFilterByClass;
};
FaresFilterByClassFactory.$inject = ['DataFilterFactory'];
module.exports = FaresFilterByClassFactory;